import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
export var SITEMAP_LANGUAGE_LABELS = function(strictLocalize) {
    var _obj;
    return _obj = {}, _define_property(_obj, Language.ENG, strictLocalize({
        id: "vmsq+x",
        defaultMessage: [
            {
                type: 0,
                value: "English (US)"
            }
        ]
    })), _define_property(_obj, Language.FRA, strictLocalize({
        id: "k/qdtu",
        defaultMessage: [
            {
                type: 0,
                value: "French (FR)"
            }
        ]
    })), _define_property(_obj, Language.ITA, strictLocalize({
        id: "3FoZFY",
        defaultMessage: [
            {
                type: 0,
                value: "Italian (IT)"
            }
        ]
    })), _define_property(_obj, Language.DEU, strictLocalize({
        id: "PwUBu3",
        defaultMessage: [
            {
                type: 0,
                value: "German (DE)"
            }
        ]
    })), _define_property(_obj, Language.SPA, strictLocalize({
        id: "J4JIi3",
        defaultMessage: [
            {
                type: 0,
                value: "Spanish (ES)"
            }
        ]
    })), _define_property(_obj, Language.NLD, strictLocalize({
        id: "7B8Go0",
        defaultMessage: [
            {
                type: 0,
                value: "Dutch (NL)"
            }
        ]
    })), _define_property(_obj, Language.SWE, strictLocalize({
        id: "UwEy7w",
        defaultMessage: [
            {
                type: 0,
                value: "Swedish (SV)"
            }
        ]
    })), _define_property(_obj, Language.POR, strictLocalize({
        id: "PL/rhk",
        defaultMessage: [
            {
                type: 0,
                value: "Portuguese (PT)"
            }
        ]
    })), _define_property(_obj, Language.DAN, strictLocalize({
        id: "z/KauC",
        defaultMessage: [
            {
                type: 0,
                value: "Danish (DA)"
            }
        ]
    })), _obj;
};
export var SITEMAP_ROBOT_COUNTRY_LANGUAGE_LABELS = function(strictLocalize) {
    var _obj, _obj1, _obj2, _obj3;
    return _obj3 = {}, _define_property(_obj3, ISO3166Alpha3.GBR, _define_property({}, Language.ENG, strictLocalize({
        id: "9eSwUr",
        defaultMessage: [
            {
                type: 0,
                value: "English (UK)"
            }
        ]
    }))), _define_property(_obj3, ISO3166Alpha3.CHE, (_obj = {}, _define_property(_obj, Language.FRA, strictLocalize({
        id: "k8hvgV",
        defaultMessage: [
            {
                type: 0,
                value: "French (CH)"
            }
        ]
    })), _define_property(_obj, Language.DEU, strictLocalize({
        id: "MerARF",
        defaultMessage: [
            {
                type: 0,
                value: "German (CH)"
            }
        ]
    })), _obj)), _define_property(_obj3, ISO3166Alpha3.LUX, _define_property({}, Language.FRA, strictLocalize({
        id: "b6amWw",
        defaultMessage: [
            {
                type: 0,
                value: "French (LU)"
            }
        ]
    }))), _define_property(_obj3, ISO3166Alpha3.CAN, (_obj1 = {}, _define_property(_obj1, Language.ENG, strictLocalize({
        id: "2ljBIj",
        defaultMessage: [
            {
                type: 0,
                value: "English (CA)"
            }
        ]
    })), _define_property(_obj1, Language.FRA, strictLocalize({
        id: "RgPvaL",
        defaultMessage: [
            {
                type: 0,
                value: "French (CA)"
            }
        ]
    })), _obj1)), _define_property(_obj3, ISO3166Alpha3.BEL, (_obj2 = {}, _define_property(_obj2, Language.FRA, strictLocalize({
        id: "20p1ws",
        defaultMessage: [
            {
                type: 0,
                value: "French (BE)"
            }
        ]
    })), _define_property(_obj2, Language.NLD, strictLocalize({
        id: "4RDILI",
        defaultMessage: [
            {
                type: 0,
                value: "Dutch (BE)"
            }
        ]
    })), _obj2)), _define_property(_obj3, ISO3166Alpha3.AUT, _define_property({}, Language.DEU, strictLocalize({
        id: "1KjkZe",
        defaultMessage: [
            {
                type: 0,
                value: "German (AT)"
            }
        ]
    }))), _obj3;
};
